import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing, theme} from '@logistics-frontend/blocks/theme/theme'
import {cssTheme} from '@logistics-frontend/blocks/v2'

export const classes = {
  couponButton: css`
    height: ${spacing(4)};
    border-radius: 0;
    padding: 0;
    cursor: pointer;

    &:disabled {
      color: ${theme.palette.action.disabled};
    }
  `,
  titleText: css`
    display: flex;
    font-size: ${spacing(2.25)};
    width: 40%;
  `,
  couponStatusTitle: css`
    display: flex;
    width: 60%;
  `,
  statusText: css`
    display: flex;
    justify-content: flex-end;
    &:hover {
      font-weight: ${cssTheme.fonts.weights.medium};
    }
  `,
  icon: css`
    display: flex;
    align-items: center;
    max-width: ${spacing(3)};
    height: ${spacing(3)};
  `,
  closeButton: css`
    margin: ${spacing(1, 0)};
  `,
}
